import type { PageNotificationTone, PushPageNotificationInput } from '../hooks/usePageNotifications';

/** Map common page banners / thrown errors into the shared toast shape. */
export function pageFeedbackToToast(
  input:
    | { kind: 'error'; message: string; title?: string }
    | { kind: 'success'; message: string; title?: string }
    | { kind: 'info'; message: string; title?: string },
): PushPageNotificationInput {
  if (input.kind === 'error') {
    return {
      tone: 'error' satisfies PageNotificationTone,
      title: input.title?.trim() || 'Something went wrong',
      lines: [input.message],
    };
  }
  if (input.kind === 'success') {
    return {
      tone: 'ok',
      title: input.title?.trim() || input.message,
      lines: input.title ? [input.message] : [],
    };
  }
  return {
    tone: 'info',
    title: input.title?.trim() || input.message,
    lines: input.title ? [input.message] : [],
  };
}
